/*
 * @Author: bz2021
 * @Date: 2025-07-01 19:37:49
 * @Description:
 */

import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import ForgotPassword from "./components/ForgetPwd";
import Home from "./pages/Home";
import UserList from "./pages/UserList";
import MyUserList from "./pages/MyUserList";
import StoreManagement from "./pages/StoreManagement";
import ProductDetailPage from "./pages/ProductDetailPage";
import MainLayout from "./layout/MainLayout";

const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/forget", element: <ForgotPassword /> },
  { path: "/", element: <MainLayout />, children: [
    { path: "/", element: <Navigate to="/home" replace /> },
    { path: "home", element: <Home /> },
    { path: "users", element: <UserList /> },
    { path: "my_users", element: <MyUserList /> },
    { path: "store_management", element: <StoreManagement /> },
    { path: "product-detail", element: <ProductDetailPage /> }
  ]}
]);

export default router;
